import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface OptionCardProps {
  icon: ReactNode;
  title: string;
  description?: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

/** Selectable option card — onboarding "What best describes you?" per DESIGN.md §9. */
export function OptionCard({ icon, title, description, selected = false, onClick, className }: OptionCardProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cn(
        "flex w-full items-start gap-3 rounded-md border bg-surface-2 p-4 text-left transition-colors",
        "focus-visible:outline-2 focus-visible:outline-primary",
        selected ? "border-primary bg-primary-soft" : "border-border hover:border-border-strong",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn("mt-0.5 shrink-0", selected ? "text-text-primary" : "text-text-secondary")}
      >
        {icon}
      </span>
      <span>
        <span className="block text-body font-medium text-text-primary">{title}</span>
        {description && <span className="mt-0.5 block text-small text-text-secondary">{description}</span>}
      </span>
    </button>
  );
}
